import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import i18n from "i18next";
import { getContentLanguage } from "../../common/content_language";
import { LuX } from "react-icons/lu";

require("./_visor.scss");

export default class Visor extends Component {
  constructor(props) {
    super(props);
    this.state = { previewKey: 0 };
    this._prevVisorVisible = props.visorVisible;
  }

  shouldComponentUpdate(nextProps, nextState) {
    const shouldUpdate =
      this.props.visorVisible ||
      nextProps.visorVisible ||
      JSON.stringify(this.props.state) !== JSON.stringify(nextProps.state) ||
      nextState.previewKey !== this.state.previewKey;
    return shouldUpdate;
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.visorVisible && !prevState._prevVisorVisible) {
      return { previewKey: prevState.previewKey + 1, _prevVisorVisible: true };
    }
    if (!nextProps.visorVisible) {
      return { _prevVisorVisible: false };
    }
    return null;
  }

  render() {
    /* if (this.props.state.navItemSelected === 0) {
            return (
                <div />
            );
        }*/

    return (
      <Modal
        className="visor modalVisorContainer"
        show={this.props.visorVisible}
        backdrop
        size="lg"
        centered
        aria-labelledby="contained-modal-title-lg"
        onHide={(e) => {
          this.props.onVisibilityToggled();
        }}
      >
        <Modal.Header style={{ padding: 0, border: "none", background: "#ffffff", flexShrink: 0 }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              padding: "10px 16px",
              borderBottom: "1px solid #cbd5e1",
              borderRadius: "16px 16px 0 0",
            }}
          >
            <span id="previewTitle" style={{ color: "#1e293b", fontWeight: 600, lineHeight: 1.3 }}>
              {i18n.t("Preview")}
            </span>
            <button
              type="button"
              aria-label="Close"
              onClick={this.props.onVisibilityToggled}
              style={{
                width: 32,
                height: 32,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "none",
                background: "none",
                borderRadius: 8,
                cursor: "pointer",
                color: "#8b95af",
                padding: 0,
                flexShrink: 0,
              }}
              onMouseEnter={(e) => (e.currentTarget.style.background = "#f1f5f9")}
              onMouseLeave={(e) => (e.currentTarget.style.background = "none")}
            >
              <LuX size={18} />
            </button>
          </div>
        </Modal.Header>

        <Modal.Body
          style={{
            position: "relative",
            top: "-1px",
            width: "100%",
            height: "97%",
            padding: "0px",
            backgroundColor: "#555",
          }}
        >
          <iframe
            id="visor_iframe"
            key={this.state.previewKey}
            ref={(el) => {
              if (el !== null && this.props.visorVisible) {
                el.contentWindow.document.open();
                const stateToExport = {
                  ...this.props.state,
                  preview: true,
                  globalConfig: {
                    ...this.props.state.globalConfig,
                    __editorLanguage: i18n.language,
                    contentLanguage: getContentLanguage(),
                    __trainingId:
                      window.idealStudioTrainingId ||
                      this.props.state?.globalConfig?.__trainingId ||
                      this.props.state?.globalConfig?.trainingId ||
                      null,
                    __ideaLibraryRootUrl:
                      window.ideaLibraryRootUrl ||
                      this.props.state?.globalConfig?.__ideaLibraryRootUrl ||
                      this.props.state?.globalConfig?.ideaLibraryRootUrl ||
                      null,
                  },
                };
                el.contentWindow.document.write(IdealStudio.Visor.exportPage(stateToExport));
                el.contentWindow.document.close();
              }
            }}
            style={{ width: "100%", height: "100%", border: 0 }}
            allow="autoplay"
            allowFullScreen
            frameBorder="0"
          />
        </Modal.Body>
      </Modal>
    );
  }
}

Visor.propTypes = {
  /**
   * Indica si se debe mostrar o no el visor
   */
  visorVisible: PropTypes.bool,
  /**
   * Muestra o oculta el visor
   */
  onVisibilityToggled: PropTypes.func.isRequired,
  /**
   * Estado de la aplicación que se pasa al visor
   */
  state: PropTypes.object.isRequired,
};
